// extracted by mini-css-extract-plugin
export var actionText = "_qm-4";
export var container = "_qm-0";
export var leftSection = "_qm-1";
export var rightSection = "_qm-2";
export var settingsButton = "_qm-6";
export var settingsIcon = "_qm-7";
export var shortcut = "_qm-5";
export var shortcutGroup = "_qm-3";